import React from 'react'
import { CHIP_100, CHIP_500, CHIP_25 } from '../../../../icons'
import { getMediaUrl } from '../../../../utils/utils'

const getChipIcon = (chip) => {
  switch (chip) {
    case '500':
      return getMediaUrl(CHIP_500)
    case '100':
      return getMediaUrl(CHIP_100)
    case '25':
      return getMediaUrl(CHIP_25)
    default:
      return null
  }
}

export const Chips = ({ config, position, oppPosition, playersBets }) => {
  if (!playersBets) return null

  const bet = playersBets[position]

  if (!bet) return null
  if (typeof bet !== 'number') return null

  const chipsCount = bet ? Math.ceil(bet * 2) : 0

  if (!oppPosition || !position || chipsCount === 0) return null

  const chipsValue = bet * 50
  const c500 = parseInt(chipsValue / 500)
  const c500left = chipsValue % 500
  const c100 = parseInt(c500left / 100)
  const c100left = c500left % 100
  const c25 = parseInt(c100left / 25)
  const chips = {
    '500': c500 || 0,
    '100': c100 || 0,
    '25': c25 || 0,
  }
  const chipsArray = Object.entries(chips).reduce((acc, curr) => {
    const [key, value] = curr
    const arr = new Array(value).fill(key)
    return [...acc, ...arr]
  }, [])

  return (
    <div
      style={{
        zIndex: 200,
      }}
    >
      {chipsArray.map((chip, chipIndex) => (
        <img
          resizeMode="cover"
          key={chipIndex}
          alt="chip"
          style={{
            position: 'absolute',
            top: config.chipTop && config.chipTop - chipIndex * 2,
            left: config.chipLeft,
            right: config.chipRight,
            bottom: config.chipBottom && config.chipBottom + chipIndex * 2,
            maxHeight: 18,
            maxWidth: 20,
            zIndex: 200,
          }}
          src={getChipIcon(chip)}
        />
      ))}
      <div
        style={{
          backgroundColor: 'green',
          borderRadius: 8,
          paddingHorizontal: 5,
          position: 'absolute',
          top: config.chipTop + 20,
          left: config.chipLeft - 20,
          right: config.chipRight - 20,
          bottom: config.chipBottom - 20,
          minWidth: 60,
          maxWidth: 80,
        }}
      >
        <div
          style={{
            textAlign: 'center',
            fontSize: 12,
            fontWeight: '700',
            color: 'white',
          }}
        >
          {parseFloat(bet?.toFixed(2))}BB
        </div>
      </div>
    </div>
  )
}
